<template>
  <b-modal id="createTeamUserDataModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmteamuserdata.createTeamUserDataModalHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row v-if="team">
      <b-col>
        <Create :team="team"></Create>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import Create from '../Create.vue'
export default {
  name: 'EXCMTeamUserDataCreateModal',
  components: {
    Create
  },
  computed: {
    show () {
      return this.$store.state.modals.excmteamuserdata.create.show
    },
    teamObject () {
      return this.$store.state.modals.excmteamuserdata.create.team
    },
    close () {
      return this.$store.state.modals.excmteamuserdata.create.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'teamObject': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      team: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.teamObject) {
        this.team = Object.assign({}, this.teamObject)
        this.$store.state.modals.excmteamuserdata.create.show = 0
        this.$store.state.modals.excmteamuserdata.create.team = null
        this.$bvModal.show('createTeamUserDataModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmteamuserdata.create.close = 0
      }
      this.$bvModal.hide('createTeamUserDataModal')
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
